import { PersonnelService } from "@/common/api.service";
import { FATAL_FETCH_ERROR } from "../person/mutations";
import { SET_TOASTER_MESSAGE } from "../this_app/mutations";
import {
    CANCEL_COURSE_TYPE_EDIT_STATE,
    FETCH_COURSE_TYPE,
    FETCH_COURSE_TYPE_LIST,
    SAVE_COURSE_TYPE,
    SAVE_EDITED_COURSE_TYPE,
    SAVE_NEW_COURSE_TYPE
} from "./actions";
import {
    FETCH_COURSE_TYPE_LIST_END,
    FETCH_COURSE_TYPE_START,
    LOAD_COURSE_TYPE_TO_EDIT,
    RESET_DEFAULT_COURSE_TYPE_TO_EDIT,
    RESET_DEFAULT_NEW_COURSE_TYPE,
    RESET_DEFAULT_NEW_COURSE_TYPE_LIST,
    SET_COURSE_TYPE,
    TOGGLE_COURSE_TYPE_EDIT_STATE,
    TOGGLE_EDIT_COURSE_TYPE_DIALOG,
    TOGGLE_NEW_COURSE_TYPE_DIALOG,
    UPDATE_ADD_COURSE_TYPE_FIELD,
    UPDATE_COURSE_TYPE_FIELD
} from "./mutations";

const getDefaultState = () => {
    return {
        loadingCourseType: false,
        courseType: {
            name: ""
        },
        courseTypeList: [],
        editCourseTypeDialog: false,
        addCourseType: {
            name: ''
        },
        editCourseType: {},
        addCourseTypeDialog: false,
        editStateCourseTypes: {
            name: false
        }
    };
};

const state = {
    loadingCourseType: false,
    courseType: {},
    courseTypeList: [],
    editCourseTypeDialog: false,
    addCourseType: {
        name: ''
    },
    editCourseType: {},
    addCourseTypeDialog: false,
    editStateCourseTypes: {
        name: false
    }
};

const getters = {
    courseType(state) {
        return state.courseType;
    },
    courseTypeList(state) {
        return state.courseTypeList;
    },
    editStateCourseTypes(state) {
        return state.editStateCourseTypes;
    },
    getCourseTypeNameById: state => courseTypeId => {
        const courseType = state.courseTypeList.find(
            courseType => courseType.id == courseTypeId
        );
        if (courseType) {
            return courseType.name;
        }
    },
    addCourseTypeDialog(state) {
        return state.addCourseTypeDialog;
    }
};

const actions = {
    [FETCH_COURSE_TYPE_LIST]({ commit }) {
        return PersonnelService.getAllCourseTypes()
            .then(({ data }) => {
                commit(FETCH_COURSE_TYPE_LIST_END, data);
            })
            .catch(error => {
                commit(FATAL_FETCH_ERROR, {
                    state: true,
                    value: "FETCH_COURSE_TYPE_LIST"
                });
                throw new Error(error);
            });
    },
    [FETCH_COURSE_TYPE]({ commit }, courseTypeId) {
        commit(FETCH_COURSE_TYPE_START);
        return PersonnelService.getCourseType(courseTypeId)
            .then(({ data }) => {
                commit(SET_COURSE_TYPE, data);
            })
            .catch(error => {
                throw new Error(error);
            });
    },
    [CANCEL_COURSE_TYPE_EDIT_STATE]({ commit, dispatch }, params) {
        dispatch(FETCH_COURSE_TYPE_LIST);
        commit(TOGGLE_COURSE_TYPE_EDIT_STATE, params.field);
    },
    [SAVE_COURSE_TYPE]({ commit, dispatch }, params) {
        return PersonnelService.updateCourseTypeDetails(params).then(
            ({ data }) => {
                commit(TOGGLE_COURSE_TYPE_EDIT_STATE, params.field);
                dispatch(FETCH_COURSE_TYPE, params.courseType.id);
                return data;
            }
        );
    },
    [SAVE_EDITED_COURSE_TYPE]({ commit, dispatch }) {
        //Put this here as it will get lost with reset
        const editedCourseType = state.editCourseType;
        return PersonnelService.updateCourseType(editedCourseType)
            .then(({ data }) => {
                commit(SET_TOASTER_MESSAGE, {
                    state: true,
                    value: "Record updated"
                });
                commit(RESET_DEFAULT_COURSE_TYPE_TO_EDIT);
                dispatch(FETCH_COURSE_TYPE_LIST);
                return data;
            })
            .catch(() => {
                commit(SET_TOASTER_MESSAGE, {
                    state: true,
                    value: "Failed to update course type"
                });
            });
    },
    [SAVE_NEW_COURSE_TYPE]({ commit, dispatch }) {
        //Put this here as it will get lost with reset
        const newCourseType = state.addCourseType;
        return PersonnelService.saveCourseType(newCourseType)
            .then(() => {
                commit(SET_TOASTER_MESSAGE, {
                    state: true,
                    value: "Record saved"
                });
                dispatch(FETCH_COURSE_TYPE_LIST);
                // return data;
            })
            .catch(() => {
                commit(SET_TOASTER_MESSAGE, {
                    state: true,
                    value: "Failed to save course type"
                });
            });
    }
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
    [TOGGLE_COURSE_TYPE_EDIT_STATE](state, field) {
        state.editStateCourseTypes[field] = !state.editStateCourseTypes[field];
    },
    [UPDATE_COURSE_TYPE_FIELD](state, data) {
        state.courseType[data.field] = data.value;
    },
    [FETCH_COURSE_TYPE_START](state) {
        state.loadingCourseType = true;
    },
    [FETCH_COURSE_TYPE_LIST_END](state, data) {
        state.courseTypeList = data;
        state.isLoading = false;
    },
    [SET_COURSE_TYPE](state, data) {
        state.courseType = data;
        state.loadingCourseType = false;
    },
    [UPDATE_ADD_COURSE_TYPE_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.addCourseType[data.objectKey][0][data.key] = data.value;
        } else {
            state.addCourseType[data.key] = data.value;
        }
    },
    [UPDATE_COURSE_TYPE_FIELD](state, data) {
        if (data.objectKey !== undefined) {
            state.editCourseType[data.objectKey][0][data.key] = data.value;
        } else {
            state.editCourseType[data.key] = data.value;
        }
    },
    [RESET_DEFAULT_NEW_COURSE_TYPE](state) {
        state.addCourseType = getDefaultState().courseType;
    },
    [RESET_DEFAULT_NEW_COURSE_TYPE_LIST](state) {
        state.courseTypeList = getDefaultState().courseTypeList;
    },
    [TOGGLE_NEW_COURSE_TYPE_DIALOG](state) {
        state.addCourseTypeDialog = !state.addCourseTypeDialog;
    },
    [TOGGLE_EDIT_COURSE_TYPE_DIALOG](state) {
        state.editCourseTypeDialog = !state.editCourseTypeDialog;
    },
    [LOAD_COURSE_TYPE_TO_EDIT](state, courseTypeId) {
        // noinspection UnnecessaryLocalVariableJS
        const itemToEdit = state.courseTypeList.find(
            list => list.id == courseTypeId
        );
        state.editCourseType = itemToEdit;
    },

    [RESET_DEFAULT_COURSE_TYPE_TO_EDIT](state) {
        state.editCourseType = getDefaultState().courseType;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};
